import { useEffect } from 'react';

export default function useGoogleRecaptcha() {
  useEffect(() => {
    const { recaptchaSiteKey } = ecom.craftConfig;
    const id = 'gift-card-recaptcha';
    const recaptchaLoaded = document.getElementById(id) !== null;

    if (!recaptchaSiteKey || recaptchaLoaded) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('id', id);
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;

    document.body.appendChild(script);
  }, []);
}
